import React from 'react';
import { DataTable } from 'primereact/datatable';
import { TabView, TabPanel } from 'primereact/tabview';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import {InputText} from 'primereact/inputtext';
import './styles.css'

const OperationRequest = (props) => {
    // *** status codes and respective statuses
    // created E0001 
    // prepared E0002 
    // accepted E0007
    // issued E0004 
    // requested to Surrender E0016
    // Surrender E0010
    // reissue requested E0015
    // reissue E0011 
    // clear or requested to Surrender E0005
    // cancellation E0006
    // headerCreated = (onHCChanged)
    // headerPrepared = (onHPChanged)
    // headerAccepted = (onHAChanged)
    // headerIssued = (onHIChanged)
    // headerRequestedToSurrender = (onHRSChanged)
    // headerSurrender = (onHRChanged)
    // headerReissueRequested = (onHRRChanged)
    // headerReissued = (onHReChanged)
    // headerRequestsForClearOrSurrender = (onHRFCSChanged)
    // headerCancellation = (onHCaChanged)

    const createdRequests = props.data.filter(_ => _.currentUserStatus.includes("E0001")) ? props.data.filter(_ => _.currentUserStatus.includes("E0001")) : [];
    const preparedRequests = props.data.filter(_ => _.currentUserStatus.includes("E0002")) ? props.data.filter(_ => _.currentUserStatus.includes("E0002")) : [];
    const acceptedRequests = props.data.filter(_ => _.currentUserStatus.includes("E0007")) ? props.data.filter(_ => _.currentUserStatus.includes("E0007")) : [];
    const issuedRequests = props.data.filter(_ => (_.currentUserStatus.includes("E0004"))) ? props.data.filter(_ => (_.currentUserStatus.includes("E0004"))) : [];
    const requestsToSurrender = props.data.filter(_ => _.currentUserStatus.includes("E0016")) ? props.data.filter(_ => _.currentUserStatus.includes("E0016")) : [];
    const requestsSurrendered = props.data.filter(_ => _.currentUserStatus.includes("E0010")) ? props.data.filter(_ => _.currentUserStatus.includes("E0010")) : [];
    const reissueRequestedRequests = props.data.filter(_ => _.currentUserStatus.includes("E0015")) ? props.data.filter(_ => _.currentUserStatus.includes("E0015")) : [];
    const reissuedRequests = props.data.filter(_ => (_.currentUserStatus.includes("E0011"))) ? props.data.filter(_ => (_.currentUserStatus.includes("E0011"))) : [];
    const requestsForClearOrSurrender = props.data.filter(_ => _.currentUserStatus.includes("E0005")) ? props.data.filter(_ => _.currentUserStatus.includes("E0005")) : [];
    const plannedRequests = props.data.filter(_ => _.currentUserStatus.includes("Planned")) ? props.data.filter(_ => _.currentUserStatus.includes("Planned")) : [];
    const closedRequests = props.data.filter(wca => wca.status == "Closed")
    let requestsCancelled = props.data.filter(_ => _.currentUserStatus.includes("E0006")) ? props.data.filter(_ => _.currentUserStatus.includes("E0006")) : [];
    requestsCancelled = requestsCancelled.concat(closedRequests);



    const requestInvolvedTemplate = (rowData, column) => {
        return <div className="actionCenter">
            <Button onClick={() => props.requestRedirect(rowData,'WPRequest Involved')} type="button" icon="pi pi-eye" className="p-button-secondary" ></Button>          
        </div>;
    }

    const pendingTemplate = (rowData, column) => {
        return <div className="actionCenter">
            <Button onClick={() => props.requestRedirect(rowData,'Pending Request')} type="button" icon="pi pi-eye" className="p-button-secondary" ></Button>          
        </div>;
    }
    

    const headerCreated = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHCChanged} placeholder="Search..." />
        </div>
    )
    const headerPrepared = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHPChanged} placeholder="Search..." />
        </div>
    )
    const headerAccepted = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHAChanged} placeholder="Search..." />
        </div>
    )
    const headerIssued = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHIChanged} placeholder="Search..." />
        </div>
    )
    const headerRequestedToSurrender = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHRSChanged} placeholder="Search..." />
        </div>
    )
    const headerSurrender = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHRChanged} placeholder="Search..." />
        </div>
    )
    const headerReissueRequested = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHRRChanged} placeholder="Search..." />
        </div>
    )
    const headerReissued = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHReChanged} placeholder="Search..." />
        </div>
    )
    const headerRequestsForClearOrSurrender = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHRFCSChanged} placeholder="Search..." />
        </div>
    )
    const headerCancellation = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHCaChanged} placeholder="Search..." />
        </div>
    )
    const headerPlanned = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHPlChanged} placeholder="Search..." />
        </div>
    )

    const headerRequestInvolved = (
        <div style={{'textAlign':'right'}}>
            <InputText type="search" onInput={props.onHRRIChanged} placeholder="Search..." />
        </div>
    )

    return (

        <TabView activeIndex={props.activeIndex} >

            <TabPanel header={"WCA Created (" + createdRequests.length + ')'}>
                <DataTable
                    header={headerCreated}
                    globalFilter={props.OnHCChanged}
                    value={createdRequests}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            <TabPanel header={"WCA Prepared (" + preparedRequests.length + ')'} headerClassName ="red-text">
                <DataTable
                    header={headerPrepared}
                    globalFilter={props.OnHPChanged}
                    value={preparedRequests}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            <TabPanel header={"WCA Accepted (" + acceptedRequests.length + ')'}>

                <DataTable
                    header={headerAccepted}
                    globalFilter={props.OnHAChanged}
                    value={acceptedRequests}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            <TabPanel header={"WCA Issued (" + issuedRequests.length + ')'} headerClassName ="red-text">

                <DataTable
                    header={headerIssued}
                    globalFilter={props.OnHIChanged}
                    value={issuedRequests}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            <TabPanel header={"WCA Requested To Surrender (" + requestsToSurrender.length + ')'}>
                <DataTable
                    header={headerRequestedToSurrender}
                    globalFilter={props.OnHRSChanged}
                    value={requestsToSurrender}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            <TabPanel header={"WCA Surrendered (" + requestsSurrendered.length + ')'} headerClassName ="red-text">

                <DataTable
                    header={headerSurrender}
                    globalFilter={props.OnHRChanged}
                    value={requestsSurrendered}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            
            <TabPanel header={"Reissue Requested WCA (" + reissueRequestedRequests.length + ')'}>

                <DataTable
                    header={headerReissueRequested}
                    globalFilter={props.OnHRRChanged}
                    value={reissueRequestedRequests}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>
            
            
            
            <TabPanel header={"WCA Reissued (" + reissuedRequests.length + ')'} headerClassName ="red-text">

                <DataTable
                    header={headerReissued}
                    globalFilter={props.OnHReChanged}
                    value={reissuedRequests}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            <TabPanel header={"WCA Cleared (" + requestsForClearOrSurrender.length + ')'}>

                <DataTable
                    header={headerRequestsForClearOrSurrender}
                    globalFilter={props.OnHRFCSChanged}
                    value={requestsForClearOrSurrender}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={pendingTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            <TabPanel header={"WCA Cancelled (" + requestsCancelled.length + ')'} headerClassName ="green-text">

                <DataTable
                    header={headerCancellation}
                    globalFilter={props.OnHCaChanged}
                    value={requestsCancelled}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={requestInvolvedTemplate} header="Action"/>
                </DataTable>
            </TabPanel>

            <TabPanel header={"WCA Planned (" + plannedRequests.length + ')'}>
                <DataTable
                    header={headerPlanned}
                    globalFilter={props.OnHPlChanged}
                    value={plannedRequests}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={requestInvolvedTemplate} header="Action"/>
                </DataTable>
            </TabPanel>


            <TabPanel header={"Request Involved (" + props.requestInvolved.length + ')'}>

                <DataTable 
                    header={headerRequestInvolved}
                    globalFilter={props.OnHRRIChanged}
                    value={props.requestInvolved}
                    responsive
                    className="p-datatable-customers animated fadeIn"
                    rowHover
                    selectionMode="single"
                    selection={props.selectedCar}
                    paginator
                    rows={8}
                    emptyMessage="No lists found"  >
                    
                    <Column field="requestNum" sortable={true} header="WCA Number" />
                    <Column field="workCenter" sortable={true} header="Work Center"  />
                    <Column field="requestDate" sortable={true} header="Request Date" />
                    <Column field="permitDescription" sortable={true} header="WCA Description" />
                    <Column field="workOrderNo" sortable={true} header="SAP WorkOrder No" />
                    <Column field="workOrderDescription" sortable={true} header="SAP WorkOrder Description" />
                    <Column field="status" sortable={true} header="Status" />
                    <Column field="permitType" sortable={true} header="Permit Type" />
                    <Column field="action" body={requestInvolvedTemplate} header="Action"/>
                </DataTable>
            </TabPanel>
        </TabView>
    );
}

export default OperationRequest;